import React, { useState } from "react";
import "./styles.css";
import DateAndCity from "./Date_and_City";
import WeatherDetails from "./Weather_details";
import Temperature from "./Temperature";
import ForeCast from "./foreCast";
import axios from "axios";
import LoadingIcons from "react-loading-icons";
import { useGlobalWeather } from "./Stores";

export default function SearchBar() {
  var [city, setCity] = useState(null);
  function getIPAddress() {
    let url = "https://ipapi.co/json";
    axios
      .get(url)
      .then(recieveIP)
      .catch((error) => {
        // Handle the error here
        console.error("Error fetching IP:", error);
        // Set the city to "Paris" in case of an error
        setCity("Paris");
      });
  }
  function recieveIP(response) {
    setCity(response.data.city);
  }
  const { globalWeather, setGlobalWeather } = useGlobalWeather({
    loaded: false,
  });

  function search() {
    const apiKey = "50fa4024e3b1d5eac2f51ab18a47e997";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then((response) => {
      setGlobalWeather({
        loaded: true,
        temp: response.data.main.temp,
        humidity: response.data.main.humidity,
        wind: Math.round(response.data.wind.speed),
        description: response.data.weather[0].description,
        icon: response.data.weather[0].icon,
        dt: response.data.dt,
        name: response.data.name,
        country: response.data.sys.country,
        lon: response.data.coord.lon,
        lat: response.data.coord.lat,
      });
    });
  }

  function getCityInput(event) {
    setCity(event.target.value);
    // console.log(city);
  }

  function searchForCity(event) {
    event.preventDefault();
    search();
  }
  if (globalWeather.loaded) {
    return (
      <div className=" container mt-3 px-1">
        <form className="row" onSubmit={searchForCity}>
          <div className="col-9">
            <input
              onChange={getCityInput}
              placeholder="Type in your city..."
              type="text"
              className="form-control"
              id="city-input"
            />
          </div>

          <div className="col-3 ">
            <input
              value="Search"
              type="submit"
              className="btn btn-primary w-100"
              id="search-btn"
            />
          </div>
        </form>
        <DateAndCity data={globalWeather} />
        <WeatherDetails data={globalWeather} />
        <Temperature data={globalWeather} />
        <ForeCast data={globalWeather} />
      </div>
    );
  } else {
    if (city) {
      search();
      return <LoadingIcons.ThreeDots />;
    } else {
      getIPAddress();
      return <LoadingIcons.ThreeDots />;
    }
  }
}
